module.exports = __webpack_public_path__ + "static/media/shape_arctic-secound.e7473207.svg";